// extracted by mini-css-extract-plugin
export default {"Blocks":"Abilities_Blocks__8GCY7","ThirdBlockImg":"Abilities_ThirdBlockImg__9UqFn"};